module.exports = __webpack_public_path__ + "static/img/6-1.1141b9e2.png";